// §6.8 contact surface constants — single source for footer, palette, story
// outro, and the skim hub. Kept free of component imports so any surface
// (and any test mock) can consume them without pulling in shell behavior.

export const CONTACT_EMAIL = 'galentidesign@gmail.com'
export const LINKEDIN_URL = 'https://www.linkedin.com/in/jgalenti'
export const SOURCE_URL = 'https://github.com/galentidesign/portfolio'
